import api from './api.js';

class Countries {
    constructor(){
        this.url_countries = 'countries'
    }

    all(){
        return api.get(this.url_countries);
    }
    states(id = 1){
        return api.get(`${this.url_countries}/${id}/states`);
    }
}

export default new Countries;
